import { Navigate, Route, Routes } from "react-router-dom";

import { SingleSignOn } from "./pages";
import GDPRCookiePolicy from "./pages/privacy/GDPRCookiePolicy";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";

import { AuthProvider, ProtectedRoute } from "./features/Auth";
import AuthError from "./features/Auth/AuthError";

import { HeroUIProvider } from "@heroui/system";

import { Home } from "@/features/Home";
import WorkspaceStart from "@/features/Workspaces/WorkspaceStart";

import { I18nProvider } from "@react-aria/i18n";

import { Admin } from "@/features/Admin";
import { Tableau } from "@/features/Tableau";

import ToolsComponentWrapper from "@/components/Prompt/tools/";
import AIPrompt from "@/pages/AIPrompt";
import { useEffect } from "react";
// import { useAuth } from "./features/Auth/context";
// import { getUserData } from "./features/Auth/service";
import { useAppVersionChecker } from "./hooks/useAppVersionChecker";
import { useClearAnalyticsCookies } from "./hooks/useClearAnalyticsCookies";
import { useRemoveTrailingSlash } from "./hooks/useRemoveTrailingSlash";
import "./i18n";

export function RedirectBackend() {
  useEffect(() => {
    const base = (import.meta.env.VITE_BACKEND_URL as string).replace(
      /\/+$/,
      "",
    );
    // Real page navigation (not fetch/XHR)
    window.location.replace(`${base}/sso/cognito/entry`);
  }, []);

  return null;
}

const LOCALE = "fr-Fr";

export default function App() {
  useRemoveTrailingSlash();
  useAppVersionChecker();
  useClearAnalyticsCookies();

  return (
    <I18nProvider locale={LOCALE}>
      <HeroUIProvider locale={LOCALE}>
        <AuthProvider>
          <Routes>
            {/* sso redirect */}
            <Route path="/auth/redirect" element={<RedirectBackend />} />
            {/* get user */}
            <Route path="/auth/sso-user" element={<SingleSignOn />} />
            <Route path="/auth/error" element={<AuthError />} />

            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<GDPRCookiePolicy />} />

            <Route
              path="/"
              element={<Navigate to="/workspace-start" replace />}
            />
            <Route
              path="/workspace-start"
              element={
                <ProtectedRoute>
                  <WorkspaceStart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Navigate to="/workspace-start" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gate"
              element={
                <ProtectedRoute>
                  <Navigate to="/workspace-start" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/w/:group/:workspace/dashboard/:uuid?"
              element={
                <ProtectedRoute>
                  <Home>
                    <Tableau />
                  </Home>
                </ProtectedRoute>
              }
            />
            <Route
              path="/w/:group/:workspace/admin/*"
              element={
                <ProtectedRoute>
                  <Home>
                    <Admin />
                  </Home>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai/*"
              element={
                <ProtectedRoute>
                  <AIPrompt
                    client="gate"
                    tools={<ToolsComponentWrapper />}
                    path_route="ai"
                  />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={<Navigate to="/auth/redirect" replace />}
            />
          </Routes>
        </AuthProvider>
      </HeroUIProvider>
    </I18nProvider>
  );
}
